// Hero region select
const regionSelect = document.getElementById("select-region");

if (typeof regionSelect !== "undefined" && regionSelect !== null) {
  regionSelect.addEventListener("change", (event) => {
    let chosenValue = event.target.value;
    if (chosenValue !== undefined && chosenValue !== "") {
      window.location = event.target.value;
    }
  });
}
